import React, { Component } from "react";
import { connect } from "react-redux";
import { Dropdown, Menu } from "semantic-ui-react";
import PropTypes from "prop-types";

import { hasPermission, isLoggedIn } from "../../../reducer";
import { Link } from "react-router-dom";
import { Translate } from "react-localize-redux";


class ClockLink extends Component {

    render() {

        if (this.props.loggedIn) {
            if (this.props.mobile) {
                return (
                    <Translate>
                        {({ translate }) =>
                            <Menu.Item>
                                <Menu.Header>{translate("clock.header")}</Menu.Header>
                                <Menu.Menu>
                                    {this.props.hasPermission("clock") &&
                                    <Menu.Item name={translate("clock.links.clock")} as={Link}
                                               to={"/clock"}/>}
                                    {this.props.hasPermission("clockAdmin") &&
                                    <Menu.Item name={translate("clock.links.reports")} as={Link}
                                               to={"/clock/admin/reports"}/>}
                                    {this.props.hasPermission("clock") &&
                                    <Menu.Item name={translate("clock.links.activity")}
                                               as={Link} to={"/clock/admin/active"}/>}
                                    {this.props.hasPermission("schedule") &&
                                    <Menu.Item name={translate("clock.links.schedule")}
                                               as={Link} to={"/clock/schedule/view"}/>}
                                    {this.props.hasPermission("scheduleManage") &&
                                    <Menu.Item name={translate("clock.links.scheduleManage")}
                                               as={Link} to={"/clock/schedule"}/>}

                                </Menu.Menu>
                            </Menu.Item>}
                    </Translate>
                );
            }
            return (
                <Translate>
                    {({ translate }) =>
                        <Dropdown item text={translate("clock.header")}>
                            <Dropdown.Menu>
                                {this.props.hasPermission("clock") && <Dropdown.Item as={Link}
                                                                                     to={"/clock"}>{translate("clock.links.clock")}</Dropdown.Item>}
                                {this.props.hasPermission("clockAdmin") && <Dropdown.Item as={Link}
                                                                                          to={"/clock/admin/reports"}>{translate("clock.links.reports")}</Dropdown.Item>}
                                {this.props.hasPermission("clock") && <Dropdown.Item as={Link}
                                                                                     to={"/clock/admin/active"}>{translate("clock.links.activity")}</Dropdown.Item>}
                                {this.props.hasPermission("schedule") && <Dropdown.Item as={Link}
                                                                                     to={"/clock/schedule/view"}>{translate("clock.links.schedule")}</Dropdown.Item>}
                                {this.props.hasPermission("scheduleManage") && <Dropdown.Item as={Link}
                                                                                     to={"/clock/schedule"}>{translate("clock.links.scheduleManage")}</Dropdown.Item>}
                            </Dropdown.Menu>
                        </Dropdown>}
                </Translate>
            );
        }

        return null;
    }
}

ClockLink.contextTypes = {
    router: PropTypes.object
};


const mapStateToProps = state => ({
    loggedIn: isLoggedIn(state),
    isAdmin: hasPermission(state, "clockAdmin"),
    hasPermission: (permission) => hasPermission(state, permission)
});


export default connect(
    mapStateToProps,
    null,
    null
)(ClockLink);



// WEBPACK FOOTER //
// ./src/scenes/Clock/Links/index.js